import React from 'react'
import PropTypes from 'prop-types'
import styles from './layout.module.css'
import { rhythm } from '../utils/typography'
import Hero from './hero'
import BasicHero from './basic-hero'
import Upsell from './upsell'
import InfoBox from './info-box'
import ImagePanel from './image-panel'
import Footer from './footer'

export const LayoutType = {
  Home: 'home',
  News: 'news',
  About: 'about',
  Article: 'article',
  Terms: 'terms',
}

export const Layout = (props) => {
  const { children, type } = props
  return (
    <>
      <div className={styles.top}>
        {renderPageTop(type)}
      </div>
      <div style={getRythmStyle()}>
        <main>{children}</main>
      </div>
      {renderPageBottom(type)}
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.array.isRequired,
  type: PropTypes.string.isRequired,
}

const getRythmStyle = () => {
  return {
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: rhythm(30),
    padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
  }
}

// *************************************************
// TOP
// *************************************************

const renderPageTop = type => {
  if (type === LayoutType.Home) {
    return renderTopForHome()
  } if (type === LayoutType.News) {
    return renderTopForHome()
  } else if (type === LayoutType.Article) {
    return renderTopForArticle()
  } else if (type === LayoutType.About) {
    return renderTopForAboutUs()
  } else if (type === LayoutType.Terms) {
    return renderTopForTerms()
  } 
}

const renderTopForHome = () => {
  return (
    <>
      <Hero headline="Find the best gas & electric deals for your business." useH1={true} />
      <Upsell heading="Switching commercial energy is easy..."/>
      <ImagePanel />
      <InfoBox />
    </>
  )
}

const renderTopForArticle = () => {
  return (
    <>
      <Hero headline="Find the best gas & electric deals for your business." />
      <Upsell empty={true}/>
    </>
  )
}

const renderTopForAboutUs = () => {
  return (
    <>
      <BasicHero nav={true}/>
    </>
  )
}

const renderTopForTerms = () => {
  return (
    <>
      <BasicHero />
    </>
  )
}

// *************************************************
// BOTTOM
// *************************************************

const renderPageBottom = type => {
  if (type === LayoutType.Article) {
    return renderBottomForArticle()
  } else {
    return renderBottomForNormal()
  }
}

const renderBottomForNormal = () => {
  return (
    <></>
  )
}

const renderBottomForArticle = () => {
  return (
    <>
      <Upsell heading="Switching commercial energy is easy..."/>
      <ImagePanel />
      <InfoBox />
    </>
  )
}